import styled from 'styled-components';

export const StyledCreatProjectModal = styled.div`
  width: 100%;

  .title {
    display: block;
    font-size: 20px;
    line-height: 24px;
    margin: 0 0 10px;
  }

  .text-holder {
    margin: 0 0 20px;

    p {
      margin: 0 0 20px;
    }
  }

  .btn-holder {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }
`;
